module.exports = "<div class=\"m-knowledge-info\">\r\n    <div class=\"container\">\r\n        <div class=\"block-title\">\r\n            <i class=\"u-icon u-icon-knowledge\"></i>\r\n        </div>\r\n    </div>\r\n    <knowledge-tabs :list=\"tabs\"></knowledge-tabs>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/gallery/knowledge-info.html
// module id = 323
// module chunks = 0